module.exports = __webpack_public_path__ + "static/jay-258f4c87bc105dac0a980409a725352b.png";